module.exports = __webpack_public_path__ + "630dbf14a32f16baba1a4877c5243ece.svg";